// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".text[data-v-2058bfe1]{font-family:Montserrat,\"system-ui\",-apple-system,BlinkMacSystemFont,\"Segoe UI\",Roboto,\"Helvetica Neue\",Arial,\"Noto Sans\",sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",\"Segoe UI Symbol\",\"Noto Color Emoji\";font-weight:500;font-size:.6875rem;--text-opacity:1;color:#707070;color:rgba(112,112,112,var(--text-opacity));line-height:1rem;text-transform:capitalize}", ""]);
// Exports
module.exports = exports;
